const $accordion =  $('.js-accordion');
const $accordionSections = $accordion.find('.accordion__section');

/**
 * Accordion Sections
 *
 * @return {Void}
 */
$accordionSections.each(function() {
  $(this).find('.accordion__head').on('click', function() {
    const $this = $(this);
    const $parent = $this.closest('.accordion__section');
    $parent.toggleClass('is-active');
    $parent.find('.accordion__body').slideToggle();
  })
})
